import React, { useCallback } from 'react';
import { HashLink } from 'react-router-hash-link';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Icon } from 'roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';

const TopicLink = styled(Flex)`
  justify-content: space-between;
  padding: ${themeGet('space.5')};
  background-color: white;
  border-radius: ${themeGet('radii.default')};
  color: inherit;

  &:hover {
    text-decoration: underline;
    color: inherit;
  }

  &:focus {
    outline-color: ${themeGet('colors.blue')};
  }
`;

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  cursor: pointer;
`;

const menuItems = [
  { name: 'bookings', text: 'Booking Questions' },
  { name: 'QFF', text: 'Qantas Frequent Flyer Customers' },
  { name: 'payments', text: 'Payments and Changes' },
  { name: 'depositPay', text: 'Deposit Pay' },
  { name: 'modifications', text: 'Changes and cancellations' },
  { name: 'general', text: 'General Enquires and Feedback' },
  { name: 'vouchers', text: 'Vouchers' },
];

const FaqNavBar = () => {
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(
    (text) => () => {
      emitInteractionEvent({ type: 'Popular FAQ Links', value: `${text} Selected` });
    },
    [emitInteractionEvent],
  );

  return (
    <Wrapper flexDirection={['column', 'row']} justifyContent={['center', 'flex-start']}>
      {menuItems.map(({ name, text }) => (
        <TopicLink
          as={HashLink}
          to={`/faqs#${name}`}
          width={['100%', '305px']}
          mt={4}
          mr={['auto', 5]}
          ml={['auto', 0]}
          onClick={handleOnClick(text)}
          key={name}
          data-testid={name}
          aria-label={text}
        >
          {text}
          <Icon name="chevronRight" color="red" />
        </TopicLink>
      ))}
    </Wrapper>
  );
};

export default FaqNavBar;
